import React, { useEffect, useRef, useState } from "react";
// import { useNavigate } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";
import "react-phone-input-2/lib/style.css";

import PropTypes from "prop-types";
import {
  Row,
  Col,
  Form,
  Upload,
  Select,
  Space,
  Input,
  Spin,
  Button,
} from "antd";
import {
  DeleteOutlined,
  PercentageOutlined,
  SaveOutlined,
} from "@ant-design/icons";
import "antd/dist/antd.min.css";
import "../../styles/Main.scss";
import InputField from "../../common/htmlComponents/InputField";
import { ReactComponent as User } from "../../image/User.svg";
import { ReactComponent as FileImageOutlined } from "../../image/FileImageOutlined.svg";
import { ReactComponent as FileAlt } from "../../image/FileAlt.svg";
import { authUserData } from "../../utils/Helper";
import {
  deleteRequest,
  getRequest,
  patchRequest,
  postRequest,
} from "../../axios";
import ButtonField from "../../common/htmlComponents/ButtonField";
import TextAreaField from "../../common/htmlComponents/TextAreaField";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import PaymentBankFields from "../vendor/PaymentBankFields";
import PaymentLCFields from "../vendor/PaymentLCFields";
// import VendorDocumentGrid from "./VendorDocumentGrid";
// import PaymentBankFields from "./PaymentBankFields";
// import PaymentLCFields from "./PaymentLCFields";

const PaymentMyVendor = ({
  paymenttermsId,
  VendorId,
  setPaymentTermsId,
  gstVendorId,
  gstValue,
  setShowPaymentPersonReleasedField,
}) => {
  const { t } = useTranslation();
  // const { id } = useParams();
  // const navigate = useNavigate();
  const CompanyId = authUserData()?.company ? authUserData()?.company : null;
  // const VendorId = id ? atob(id) : null;

  const formRef = useRef(null);
  const initialDocument = { vendor_company: null, document_name: null };
  const initialState = {
    company_payment_terms: [
      {
        company: authUserData()?.company ? authUserData()?.company : null,
        days_to_pay: null,
        when_to_pay: null,
        when_to_calculate: null,
        advance: 0,
        company_name: "",
        payment_security_type: "Open Credit",
        bank_garrentee_value: "",
        bank_guarantee_supply_limit_value: "",
        bank_garrentee_open_date: "",
        bank_garrentee_validity_complation_date: "",
        lc_value: "",
        lc_supply_limit_value: "",
        lc_open_date: "",
        lc_validity_complation_date: "",
        other_payment_security_type: "",
      },
    ],
  };
  const [state, setState] = useState(initialState);

  const [documentState, setDocumentState] = useState(initialDocument);
  const [btnLoading, setBtnLoading] = useState(false);
  const [apiLoading, setapiloading] = useState(false);
  // const [size, setSize] = useState(null);
  const [sizeOne, setSizeOne] = useState(null);
  // const [uploadFile, setUploadFile] = useState("");
  // const [fileLink, setFileLink] = useState(null);
  // const [fileName, setFileName] = useState(null);
  const [uploadFileOne, setUploadFileOne] = useState("");
  const [fileLinkOne, setFileLinkOne] = useState(null);
  const [fileNameOne, setFileNameOne] = useState(null);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [addedVendorId, setAddedVendorId] = useState(null);
  const [vendorDocumentList, setVendorDocumentList] = useState(null);
  const [refreshGrid, setRefreshGrid] = useState(false);
  const [vendorDocumentId, setVendorDocumentId] = useState(null);
  const [showAdditionalBankFields, setShowAdditionalBankFields] =
    useState(false);
  const [isBankFieldsValid, setIsBankFieldsValid] = useState(false);
  const [isLCFieldsValid, setIsLCFieldsValid] = useState(false);
  const [showAdditionalLCFields, setShowAdditionalLCFields] = useState(false);
  const [formKey, setFormKey] = useState(0);

  // const [showdeliveryFields, setDeliveryFields] = useState(true)
  // const url = state.msme_document;
  // const urlone = state.document_url;

  // let filename = "";
  let filenameone = "";
  // try {
  //   if (fileLink) {
  //     filename = url.split("/").pop();
  //   }
  // } catch (e) {
  //   filename = "";
  // }
  // try {
  //   if (fileLinkOne) {
  //     filenameone = urlone.split("/").pop();
  //   }
  // } catch (e) {
  //   filenameone = "";
  // }
  useEffect(() => {
    const getVendorOnboarding = async () => {
      setapiloading(true);
      try {
        // const apiResponse = await getRequest("vendor/" + VendorId);
        const apiResponse = await getRequest(
          `vendor-payment-terms/?vendor=${VendorId}`
          // `vendor-payment-terms/?vendor=${VendorId}&company=${CompanyId}`
        );
        if (apiResponse.data.success) {
          // const {
          //   unique_code,
          //   id,
          //   company_payment_terms,
          //   ...filteredResponse
          // } = apiResponse.data.data[0];
          // const firstPaymentTerm = apiResponse.data.data.vendor_company_data[0];
          // const companyPaymentTermsValues = [

          //     days_to_pay: firstPaymentTerm.days_to_pay,
          //     when_to_pay: firstPaymentTerm.when_to_pay,
          //     when_to_calculate: firstPaymentTerm.when_to_calculate,
          //     advance: firstPaymentTerm.advance,

          // ];

          setState({
            // ...apiResponse.data.data,
            // ...filteredResponse,

            company_payment_terms: apiResponse.data.data.map((payment) => {
              const {
                payment_terms,
                vendor,
                vendor_name,
                // company_name,
                remark,
                id,
                ...rest
              } = payment;
              return {
                ...rest,
                company: authUserData()?.company || null,
                // advance: advance !== null ? advance : 0,
                // advance: advance !== null ? advance : 0,
              };
            }),
          });

          let days_to_pay = null;
          let when_to_pay = null;
          let when_to_calculate = null;
          let advance = 0;
          let payment_security_type = null;
          let company_name = null;

          console.log("ddddd", apiResponse.data.data);

          if (apiResponse.data.data && apiResponse.data.data.length > 0) {
            days_to_pay = apiResponse.data?.data[0].days_to_pay || null;
            when_to_pay = apiResponse.data?.data[0].when_to_pay || null;
            when_to_calculate =
              apiResponse.data?.data[0].when_to_calculate || null;
            advance = apiResponse.data?.data[0].advance || 0;
            payment_security_type =
              apiResponse.data?.data[0].payment_security_type || null;
            company_name = apiResponse.data?.data[0].company_name || null;
          }

          state.company_payment_terms.forEach((payment) => {
            formRef.current.setFieldsValue({
              [`days_to_pay`]: days_to_pay,
              [`when_to_pay`]: when_to_pay,
              [`company_name`]: company_name,
              [`advance`]: advance,
              [`when_to_calculate`]: when_to_calculate,
              [`payment_security_type`]: payment_security_type,
            });
          });

          // Reset additional fields based on payment_security_type
          if (
            apiResponse?.data?.data[0].payment_security_type ===
            "Secure with Bank Garrentee"
          ) {
            setIsLCFieldsValid(false);
            setShowAdditionalBankFields(true);
            setShowAdditionalLCFields(false);
            formRef.current.setFieldsValue({
              lc_validity_complation_date:
                apiResponse?.data?.data[0].lc_validity_complation_date || "", // Initialize with empty string if null
              lc_open_date: apiResponse?.data?.data[0].lc_open_date || "", // Initialize with empty string if null,
              lc_supply_limit_value:
                apiResponse?.data?.data[0].lc_supply_limit_value || "", // Initialize with empty string if null,
              lc_value: apiResponse?.data?.data[0].lc_value || "", // Initialize with empty string if null
            });
          } else if (
            apiResponse?.data?.data[0].payment_security_type ===
            "Secure with LC"
          ) {
            setIsBankFieldsValid(false);
            setShowAdditionalBankFields(false);
            setShowAdditionalLCFields(true);
            formRef.current.setFieldsValue({
              bank_garrentee_open_date: "",
              bank_garrentee_validity_complation_date: "",
              bank_garrentee_value: "",
              bank_guarantee_supply_limit_value: "",
            });
          } else {
            setIsBankFieldsValid(true);
            setIsLCFieldsValid(true);
            setShowAdditionalBankFields(false);
            setShowAdditionalLCFields(false);
            formRef.current.setFieldsValue({
              bank_garrentee_open_date: "",
              bank_garrentee_validity_complation_date: "",
              bank_garrentee_value: "",
              bank_guarantee_supply_limit_value: "",
              lc_validity_complation_date:
                apiResponse?.data?.data[0].lc_validity_complation_date || "", // Initialize with empty string if null
              lc_open_date: apiResponse?.data?.data[0].lc_open_date || "", // Initialize with empty string if null,
              lc_supply_limit_value:
                apiResponse?.data?.data[0].lc_supply_limit_value || "", // Initialize with empty string if null,
              lc_value: apiResponse?.data?.data[0].lc_value || "", // Initialize with empty string if null
            });
          }

          // setWeightSizeFieldValue(apiResponse.data.data.keypersons);
        } else {
          // ErrorNotificationMsg(t("err_getSubscription"));
        }

        // setAddedVendorId(VendorId);
        // setAddedVendorId(
        //   apiResponse.data.data[0].id ? apiResponse.data.data[0].id : null // or some default value if there are no elements
        // );
        setAddedVendorId(
          apiResponse.data.data[0].id ? apiResponse.data.data[0].id : null // or some default value if there are no elements
        );

        if (paymenttermsId) {
          setFormSubmitted(true);
        } else {
          setFormSubmitted(false);
        }

        setapiloading(false);
      } catch (error) {
        setapiloading(false);
      }
    };
    if (VendorId !== null && gstVendorId === null) {
      // if (keypersonId !== null) {
      getVendorOnboarding();
    }
    if (gstVendorId === null && VendorId === null) {
      setState(initialState);
      setPaymentTermsId(null);
      formRef.current.setFieldsValue({
        days_to_pay: "",
        when_to_pay: "",
        when_to_calculate: "",
        advance: 0,
        payment_security_type: "",
        bank_garrentee_value: "",
        other_payment_security_type: "",
        company_name: "",
      });
      setShowAdditionalBankFields(false);
      setShowAdditionalLCFields(false);
      // formRef.res;
    }
    if (gstVendorId !== null && VendorId !== null) {
      setState(initialState);
      setPaymentTermsId(null);
      formRef.current.setFieldsValue({
        days_to_pay: "",
        when_to_pay: "",
        when_to_calculate: "",
        advance: 0,
        payment_security_type: "",
        bank_garrentee_value: "",
        other_payment_security_type: "",
        company_name: "",
      });
      setShowAdditionalBankFields(false);
      setShowAdditionalLCFields(false);
      // formRef.res;
    }
  }, [VendorId, gstVendorId]);

  useEffect(() => {
    const getVendorDocument = async () => {
      setapiloading(true);
      try {
        let filenameone1;
        const apiResponse = await getRequest(
          "vendor-document/" + vendorDocumentId
        );

        if (apiResponse.data.success) {
          setDocumentState({
            ...apiResponse.data.data,
          });
          // setFileLinkOne(apiResponse.data.data.document_url);
          try {
            filenameone1 = apiResponse.data.data.document_url.split("/").pop();
            setFileNameOne(filenameone1);
          } catch (e) {
            filenameone1 = "";
            setFileNameOne(null);
          }
          formRef.current.setFieldsValue({
            ...apiResponse.data.data,
          });
        } else {
          ErrorNotificationMsg(t("err_getSubscription"));
        }
        setapiloading(false);
      } catch (error) {
        setapiloading(false);
      }
    };
    if (vendorDocumentId !== null) {
      getVendorDocument();
    }
  }, [vendorDocumentId, t]);

  console.log("state", state);

  const handlePaymntSecurityTypeChange = (name, value) => {
    let updatedPaymentTerms;
    if (value === "Secure with Bank Garrentee") {
      updatedPaymentTerms = [...state.company_payment_terms];
      setIsLCFieldsValid(false);
      updatedPaymentTerms[0] = {
        ...updatedPaymentTerms[0],
        bank_garrentee_open_date: null,
        bank_garrentee_validity_complation_date: null,
        bank_garrentee_value: "",
        bank_guarantee_supply_limit_value: "",
        [name]: value,
      };
      setState({
        ...state,
        company_payment_terms: updatedPaymentTerms,
      });
      formRef.current.setFieldsValue({
        bank_garrentee_open_date: "",
        bank_garrentee_validity_complation_date: "",
        bank_garrentee_value: "",
        bank_guarantee_supply_limit_value: "",
      });
      setShowAdditionalBankFields(true);
      setShowAdditionalLCFields(false);

      // setDeliveryFields(false);
    } else if (value === "Secure with LC") {
      // setDeliveryFields(true);
      updatedPaymentTerms = [...state.company_payment_terms];
      setIsBankFieldsValid(false);
      updatedPaymentTerms[0] = {
        ...updatedPaymentTerms[0],
        lc_validity_complation_date: null,
        lc_open_date: null,
        lc_supply_limit_value: "",
        lc_value: "",
        [name]: value,
      };
      setState({
        ...state,
        company_payment_terms: updatedPaymentTerms,
      });
      formRef.current.setFieldsValue({
        [`lc_validity_complation_date`]: "",
        [`lc_open_date`]: "",
        [`lc_supply_limit_value`]: "",
        [`lc_value`]: "",
      });
      setShowAdditionalBankFields(false);
      setShowAdditionalLCFields(true);
    } else {
      updatedPaymentTerms = [...state.company_payment_terms];
      setIsBankFieldsValid(true);
      setIsLCFieldsValid(true);
      updatedPaymentTerms[0] = {
        ...updatedPaymentTerms[0],
        bank_garrentee_open_date: null,
        bank_garrentee_validity_complation_date: null,
        bank_garrentee_value: "",
        bank_guarantee_supply_limit_value: "",
        lc_validity_complation_date: null,
        lc_open_date: null,
        lc_supply_limit_value: "",
        lc_value: "",
        [name]: value,
      };
      setState({
        ...state,
        company_payment_terms: updatedPaymentTerms,
      });
      formRef.current.setFieldsValue({
        [`bank_garrentee_open_date`]: "",
        [`bank_garrentee_validity_complation_date`]: "",
        [`bank_garrentee_value`]: "",
        [`bank_guarantee_supply_limit_value`]: "",
        [`lc_validity_complation_date`]: "",
        [`lc_open_date`]: "",
        [`lc_supply_limit_value`]: "",
        [`lc_value`]: "",
      });
      setShowAdditionalBankFields(false);
      setShowAdditionalLCFields(false);
    }
    setFormKey((prevKey) => prevKey + 1);
  };
  const handleDatepickerChange = (date, dateString, name) => {
    const formattedDateString =
      dateString && dateString !== "Invalid Date" ? dateString : null;

    const updatedPaymentTerms = [...state.company_payment_terms];
    updatedPaymentTerms[0] = {
      ...updatedPaymentTerms[0],
      [name]: formattedDateString,
    };
    setState({
      ...state,
      company_payment_terms: updatedPaymentTerms,
    });
  };

  const handleEditIconClick = (id) => {
    setVendorDocumentId(id);
  };

  const handleDocumentChange = (e) => {
    let { name, value } = e.target;
    setDocumentState({ ...documentState, [name]: value !== "" ? value : null });
  };

  const handlePaymentChange = (name, value) => {
    const updatedPaymentTerms = [...state.company_payment_terms];
    updatedPaymentTerms[0] = {
      ...updatedPaymentTerms[0],
      [name]: value,
    };

    setState({
      ...state,
      company_payment_terms: updatedPaymentTerms,
    });
  };
  const handlePaymentChangeInput = (name, e) => {
    // let { value } = e.target;
    const updatedPaymentTerms = [...state.company_payment_terms];
    updatedPaymentTerms[0] = {
      ...updatedPaymentTerms[0],
      [name]: e.target.value,
    };

    setState({
      ...state,
      company_payment_terms: updatedPaymentTerms,
    });
  };

  const uploadPropsOne = {
    accept: ".jpg, .png, .jpeg",
    showUploadList: false,
    beforeUpload: (file, name) => {
      setUploadFileOne(file);
      setFileNameOne(file.name);
      return false;
    },
  };

  const handleDelete = (name) => {
    if (name === "msme_document") {
      setState((prevState) => ({
        ...prevState,
        msme_document: null,
      }));
      // setUploadFile("");
      // setFileName(null);
      // setFileLink(null);
      // setSize(null);
    } else if (name === "document_url") {
      setState((prevState) => ({
        ...prevState,
        document_url: null,
      }));
      setUploadFileOne("");
      setFileNameOne(null);
      setFileLinkOne(null);
      setSizeOne(null);
    }
  };

  const handleFileDelete = async (name) => {
    const apiResponse = await deleteRequest(
      `vendor/${12}/msme-document-delete/` //VendorId
    );
    if (apiResponse.status) {
      // message.success("Image deleted successfully");
      if (name === "msme_document") {
        // setFileName(null);
        // setFileLink(null);
        // setSize(null);
      } else if (name === "document_url") {
        setFileNameOne(null);
        setFileLinkOne(null);
        setSizeOne(null);
      }
    }
  };

  const handleRefreshGrid = () => {
    // This function will be called to trigger a refresh of the grid
    setRefreshGrid((refreshGrid) => !refreshGrid);
  };
  const handleSubmit = async () => {
    const payload = {
      company_payment_terms:
        state.company_payment_terms &&
        state.company_payment_terms.map((payment) => ({
          ...payment,
          company:
            payment.company === null
              ? authUserData()?.company
              : payment.company,
          advance: payment.advance === null ? 0 : payment.advance,
          // payment_security_type: "state",
        })),
      // other_payment_type: state.company_payment_terms.other_payment_type
    };

    try {
      setBtnLoading(true);
      let response;
      // if (paymenttermsId === null) {
      if (
        paymenttermsId === null &&
        gstVendorId === null &&
        VendorId !== null
      ) {
        response = await patchRequest(
          `vendor-payment-terms/${VendorId}/add-payment-terms/`,
          payload
        );
      }
      if (
        paymenttermsId === null &&
        gstVendorId !== null &&
        VendorId === null
      ) {
        response = await patchRequest(
          `vendor-payment-terms/${gstVendorId}/add-payment-terms/`,
          payload
        );
      }

      if (
        paymenttermsId !== null &&
        VendorId !== null &&
        gstVendorId === null
      ) {
        // apiResponse = await patchRequest(
        //   `vendor1/${VendorId}/`,
        //   formData,
        //   customerHeaders
        // );
        const url =
          VendorId !== null
            ? `vendor-payment-terms/${VendorId}/`
            : `vendor-payment-terms/${gstVendorId}/`;

        response = await patchRequest(url, payload);
      }

      // if() {
      //   response = await patchRequest(
      //     `vendor-payment-terms/${VendorId}/`,
      //     payload
      //   );
      // }

      setFormSubmitted(true);

      if (response.data.success) {
        if (response.data?.data?.company_payment_terms) {
          setPaymentTermsId(response.data.data.company_payment_terms[0].id);
          setAddedVendorId(
            response.data.data.company_payment_terms.length > 0
              ? response.data.data.company_payment_terms[0].id
              : null // or some default value if there are no elements
          );
        } else {
          setPaymentTermsId(response.data.data[0].id);

          setAddedVendorId(
            response.data.data.length > 0 ? response.data.data[0].id : null // or some default value if there are no elements
          );
        }
        //SuccessNotificationMsg(t("payment_terms_updated_successfully"));
        SuccessNotificationMsg(
          paymenttermsId === null && gstVendorId === null && VendorId !== null
            ? t("payment_terms_added_successfully")
            : t("payment_terms_updated_successfully")
        );
        // VendorId === null
        //   ? t("payment_terms_added_successfully")
        //   : t("payment_terms_updated_successfully")
        // setState(initialState);
        // formRef.current.setFieldsValue(initialState);
        setBtnLoading(false);
        setShowPaymentPersonReleasedField(true);
        //navigate("/employee");
      }
    } catch (error) {
      ErrorNotificationMsg();
      // VendorId === null
      //   ? t("error_in_adding_payment_terms")
      //   : t("error_in_updating_payment_terms")
      setBtnLoading(false);
    }
  };
  const handleVendorSubmit = async () => {
    const payload = {
      vendor_company: addedVendorId,
      document_name: documentState.document_name,
    };

    try {
      let apiResponse;
      let customerHeaders = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      const formData = new FormData();

      formData.append("document_url", uploadFileOne);
      formData.append("form_data", JSON.stringify(payload));
      if (vendorDocumentId === null) {
        apiResponse = await postRequest(
          "vendor-document/",
          formData,
          customerHeaders
        );
      } else {
        apiResponse = await patchRequest(
          `vendor-document/${vendorDocumentId}/`,
          formData,
          customerHeaders
        );
      }

      if (apiResponse.data.success === true) {
        setVendorDocumentList(apiResponse.data.data);
        // setState(initialState);
        // formRef.current.setFieldsValue(initialState);
        handleRefreshGrid();
        SuccessNotificationMsg(
          vendorDocumentId === null
            ? t("document_added_successfully")
            : t("document_updated_successfully")
        );
        setVendorDocumentId(null);
        // setDocumentState(documentState);
        // formRef.current.setFieldsValue(documentState);
        setDocumentState({ document_name: null });

        formRef.current.setFieldsValue({
          document_name: "",
        });
        setDocumentState((prevState) => ({
          ...prevState,
          document_url: null,
        }));
        setUploadFileOne("");
        setFileNameOne(null);
        setFileLinkOne(null);
        // setSizeOne(null);
        // navigate("/vendor");
      }
      setBtnLoading(false);
      // setFormSubmitted(true);
    } catch (error) {
      setBtnLoading(false);
    }
  };

  const updateBankFieldsValidity = (isValid) => {
    setIsBankFieldsValid(isValid);
  };

  const updateLCFieldsValidity = (isValid) => {
    setIsLCFieldsValid(isValid);
  };

  const handleInputChange = (e) => {
    let { name, value } = e.target;
    // value = value.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
    setState({ ...state, [name]: value !== "" ? value : null });
  };

  return (
    <>
      <Spin spinning={apiLoading}>
        <Form
          // onFinish={handleSubmit}
          autoComplete="off"
          // key={formKey}
          ref={formRef}
        >
          <Row gutter={[15]}>
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={6}
              xl={6}
              className="TextFeild gutter-row"
            >
              <Form.Item
                name="company_name"
                label={t("Company")}
                prefix={<User />}
                rules={[
                  {
                    required: true,
                    message: t("val_days_to_pay"),
                  },
                ]}
              >
                <Input disabled={true} value={state?.company_name} />
              </Form.Item>
            </Col>
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={6}
              xl={6}
              className="TextFeild gutter-row"
            >
              <Form.Item
                name="days_to_pay"
                label={t("label_days_to_pay")}
                prefix={<User />}
                rules={[
                  {
                    required: true,
                    message: t("val_days_to_pay"),
                  },
                ]}
              >
                <Input disabled={true} value={state?.days_to_pay} />
              </Form.Item>
            </Col>
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={6}
              xl={6}
              className="TextFeild gutter-row"
            >
              <Form.Item
                name="when_to_pay"
                label={t("label_when_to_pay")}
                prefix={<User />}
                rules={[
                  {
                    required: true,
                    message: t("val_when_to_pay"),
                  },
                ]}
              >
                <Input disabled={true} value={state?.when_to_pay} />
              </Form.Item>
            </Col>
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={6}
              xl={6}
              className="TextFeild gutter-row"
            >
              <Form.Item
                name="when_to_calculate"
                label={t("label_when_to_calculate")}
                prefix={<User />}
                rules={[
                  {
                    required: true,
                    message: <Trans>{t("val_when_to_calculate")}</Trans>,
                  },
                ]}
              >
                <Input disabled={true} value={state?.when_to_calculate} />
              </Form.Item>
            </Col>
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={6}
              xl={6}
              className="TextFeild gutter-row"
            >
              <Form.Item
                label={t("label_advance")}
                name="advance"
                rules={[
                  {
                    required: true,
                    message: <Trans>{t("val_advance")}</Trans>,
                  },
                  {
                    pattern: /^(100|[1-9]?[0-9])$/,
                    message: "Enter in range of 1-100",
                  },
                ]}
                initialValue={state.advance}
              >
                <Input
                  disabled={true}
                  type="number"
                  placeholder={t("pl_advance")}
                  onKeyPress={(e) => {
                    if (e.key === "." || e.key === "e") {
                      e.preventDefault(); // Prevent entering a dot
                    }
                  }}
                  onChange={(e) =>
                    // handleChange(
                    //   "advance",
                    //   parseInt(e.target.value, 10) || null
                    // )
                    handlePaymentChange(
                      "advance",
                      parseInt(e.target.value, 10) || null
                    )
                  }
                  // prefix={<PercentageOutlined />}
                />
              </Form.Item>
            </Col>
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={6}
              xl={6}
              className="TextFeild gutter-row"
            >
              <Form.Item
                name="payment_security_type"
                label={t("pl_payment_security_type")}
                prefix={<User />}
                rules={[
                  {
                    required: true,
                    message: <Trans>{t("val_payment_security_type")}</Trans>,
                  },
                ]}
              >
                <Input disabled={true} value={state?.payment_security_type} />
              </Form.Item>
            </Col>
            {showAdditionalBankFields && (
              <Col
                xs={24}
                sm={24}
                md={12}
                lg={18}
                xl={18}
                className=" gutter-row"
              >
                <PaymentBankFields
                  handleSubmit={handleSubmit}
                  formKey={formKey}
                  handlePaymentChange={handlePaymentChange}
                  handleDatepickerChange={handleDatepickerChange}
                  state={state}
                  updateBankFieldsValidity={updateBankFieldsValidity}
                />
              </Col>
            )}
            {showAdditionalLCFields && (
              <Col
                xs={24}
                sm={24}
                md={12}
                lg={18}
                xl={18}
                className=" gutter-row"
              >
                <PaymentLCFields
                  handleSubmit={handleSubmit}
                  formKey={formKey}
                  handlePaymentChange={handlePaymentChange}
                  handleDatepickerChange={handleDatepickerChange}
                  state={state}
                  updateLCFieldsValidity={updateLCFieldsValidity}
                />
              </Col>
            )}
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={6}
              xl={6}
              className="TextFeild gutter-row"
            >
              {/*       <TextAreaField
                  name="other_payment_type"
                  label={t("pl_other_payment_type")}
                  placeholder={t("pl_enter_payment_type")}
                  nonRequiredRules={t("val_about_vendor")}
                  // prefix={<About />}
                  handlePaymentChangeInput={(e) => handlePaymentChangeInput(("other_payment_type", e.target.value))}
                /> */}
              {/* 
              <Form.Item
                label={t("pl_other_payment_type")}
                name="other_payment_security_type"
              >
                <Input.TextArea
                  placeholder={t("pl_enter_payment_type")}
                  // autoSize={{ minRows: 2, maxRows: 6 }}
                  // value={state.company_payment_terms.other_payment_security_type}
                  onChange={(e) =>
                    handlePaymentChangeInput(
                      "other_payment_security_type",
                      e
                    )
                  }
                />
              </Form.Item>
            </Col>
          </Row>
          {VendorId || gstVendorId ? ( */}
              {/* <div className="FormFooter">  */}
              {/* <ButtfonField
                  <Form.Item
                    label={t("pl_other_payment_type")}
                    name="other_payment_security_type"
                  >
                    <Input.TextArea
                      placeholder={t("pl_enter_payment_type")}
                      // autoSize={{ minRows: 2, maxRows: 6 }}
                      // value={state.company_payment_terms.other_payment_security_type}
                      onChange={(e) =>
                        handlePaymentChangeInput(
                          "other_payment_security_type",
                          e
                        )
                      }
                    />
                  </Form.Item>
                </Col>
              </Row>
              {VendorId || gstVendorId ? (
                <div className="FormFooter">
                  {/* <ButtfonField
                  type="primary"
                  className="CancelGradiantBtn"
                  htmlType="button"
                  label={t("cancel")}
                  onClick={() => navigate("/vendor")}
                /> */}
              {/* <ButtonField
                type="primary"
                className="SaveGradiantBtn"
                // htmlType="Submit"
                onClick={handleSubmit}
                label={t("save")}
                loading={btnLoading}
                disabled={!isBankFieldsValid && !isLCFieldsValid} */}

              {/* ) : (
                ""
              )} */}
            </Col>
          </Row>
          <div className="subbuttonsrow">
            {/* <ButtonField
              type="primary"
              //className="SaveGradiantBtn"
              // htmlType="Submit"
              icon={<SaveOutlined />}
              onClick={handleSubmit}
              label={t("save")}
              loading={btnLoading}
              disabled={!isBankFieldsValid && !isLCFieldsValid}
            /> */}
            {/* Save
                    </ButtonField> */}
          </div>
        </Form>
      </Spin>

      {/* {authUserData()?.permission.includes("vendor|add_vendordoc") && (
          <> */}
      {/*formSubmitted && (
            <>
              <Form
                onFinish={handleVendorSubmit}
                autoComplete="off"
                ref={formRef}
              >
                <h3 className="inner-title">{t("documents")}</h3>
                <Row gutter={[15]}>
                  <Col
                    xs={24}
                    sm={24}
                    md={12}
                    lg={16}
                    xl={12}
                    className="TextFeild gutter-row"
                  >
                    <InputField
                      name="document_name"
                      className="BrowsButtonSec"
                      label={t("pl_document_name")}
                      placeholder={t("pl_enter_document_name")}
                      handleInputChange={handleDocumentChange}
                      prefix={<FileAlt />}
                      rules={t("val_document_name")}
                    />
                  </Col>
      

                  <Col
                    xs={24}
                    sm={24}
                    md={12}
                    lg={12}
                    xl={12}
                    className="TextFeild gutter-row"
                  >
                    <Form.Item
                      className="BrowsButtonSec"
                      label={t("pl_upload_document")}
                      name="document_url"
                      rules={[
                        {
                          required: false,
                          message: <Trans>{t("val_file")}</Trans>,
                        },
                      ]}
                    >


                      <Upload
                        className="BrowsButton"
                        {...uploadPropsOne}
                        name="document_url"
                      >
                        <Button icon={<FileImageOutlined />}>
                          {t("pl_upload_document")}
                        </Button>
                      </Upload>

                      {sizeOne <= 5242880 && (
                        <>
                          <Space className="uploadedfile" size={[12, 16]}>
                            <a
                              href={fileLinkOne}
                              className="link-color"
                              target="_blank"
                              rel="noreferrer"
                            >
                              {" "}
                              {fileLinkOne ? filenameone : fileNameOne}
                            </a>
                            {fileLinkOne && (
                              <DeleteOutlined
                                onClick={() => handleFileDelete("document_url")}
                              />
                            )}
                            {fileNameOne && (
                              <DeleteOutlined
                                onClick={() => handleDelete("document_url")}
                              />
                            )}
                            
                      
                          </Space>
                          
                        </>
                      )}
                    </Form.Item>
                    
                  </Col>
           
                  <div className="FormFooter">
                    <ButtonField
                      type="primary"
                      className="SaveGradiantBtn"
                      htmlType="Submit"
                      label={t("send")}
                      loading={btnLoading}
                    />
                </div>
                </Row>
              </Form>

              <VendorDocumentGrid
                refreshGrid={refreshGrid}
                vendorDocumentList={vendorDocumentList}
                setVendorDocumentList={setVendorDocumentList}
                addedVendorId={addedVendorId}
                onEditIconClick={handleEditIconClick}
              />
            </div>
          ) : (
            ""
          )}
        {/* </Form>
      </Spin> */}
    </>
  );
};
PaymentMyVendor.propTypes = {
  VendorId: PropTypes.number,
  paymenttermsId: PropTypes.func,
  setPaymentTermsId: PropTypes.func,
  gstVendorId: PropTypes.number,
  gstValue: PropTypes.number,
  setShowPaymentPersonReleasedField: PropTypes.func,
};
export default PaymentMyVendor;
